import React from 'react';
import { cn } from '@/lib/utils';

export const Container = ({ className, children, wide = false, ...rest }) => (
  <div
    className={cn(
      'mx-auto w-full px-5 sm:px-8 lg:px-10',
      wide ? 'max-w-[1400px]' : 'max-w-6xl',
      className,
    )}
    {...rest}
  >
    {children}
  </div>
);

export default Container;
